import { render, staticRenderFns } from "./oaCapacity.vue?vue&type=template&id=1b04d20e&scoped=true&"
import script from "./oaCapacity.vue?vue&type=script&lang=js&"
export * from "./oaCapacity.vue?vue&type=script&lang=js&"
import style0 from "./oaCapacity.vue?vue&type=style&index=0&id=1b04d20e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04d20e",
  null
  
)

export default component.exports